module.exports = __webpack_public_path__ + "img/LowerBlatvia.1f0fcf3f.png";